import { Box, IconButton } from '@mui/material';
// Direct path, not the `src/components` barrel: the barrel re-exports
// named-layout-block.view, which imports this file — going through it closes a
// cycle that leaves BlockHeader in the TDZ for module-scope `styled()` callers.
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import { MobileNavMenuButton } from 'src/components/Navbar/mobile-nav-menu-button';
import { usePhoneNavInPaneHeader } from 'src/components/Navbar/use-phone-nav-in-pane-header';
import { useGlobalStore } from 'src/store';
import { useScreenDimensions } from 'src/utils/system';

// Router hooks live here so the desktop path never needs a router context.
const MobileDrawerControl = () => {
  const isNavInPaneHeader = usePhoneNavInPaneHeader();

  return isNavInPaneHeader ? <MobileNavMenuButton /> : <Box height="2.45rem" />;
};

export const DrawerCloseControl = () => {
  const navbar = useGlobalStore.use.navbar();
  const setNavbar = useGlobalStore.use.setNavbar();

  const { isMobile } = useScreenDimensions();

  const showNavBarOpenButton = !navbar.isOpen && !isMobile;

  if (isMobile) return <MobileDrawerControl />;

  return (
    <Box height="2.45rem">
      {Boolean(showNavBarOpenButton) && (
        <IconButton
          onClick={() => setNavbar({ isOpen: true })}
          sx={{
            ...(!showNavBarOpenButton && {
              visibility: 'hidden',
              pointerEvents: 'none',
              position: 'absolute',
              width: 0,
              height: 'auto',
            }),
          }}
        >
          <DynamicIcon name="left_panel_open" />
        </IconButton>
      )}
    </Box>
  );
};
